import React from 'react';
import { useIntl } from 'react-intl';

import { Pressable, Text } from '@atlaskit/primitives/compiled';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	dismissPressable: {
		backgroundColor: token('elevation.surface.overlay'),
		paddingTop: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.300'),
		paddingRight: token('space.300'),
	},
});

export type DismissComponentProps = {
	dismissMessage: { id: string; defaultMessage: string; description: string };
	onDismiss: () => void;
};

export const DismissComponent = ({
	dismissMessage,
	onDismiss,
}: DismissComponentProps): React.JSX.Element => {
	const intl = useIntl();

	return (
		<Pressable
			xcss={styles.dismissPressable}
			onClick={onDismiss}
			testId="competitor-link-prompt-dismiss-button"
		>
			<Text>{intl.formatMessage(dismissMessage)}</Text>
		</Pressable>
	);
};
